import { FeatureTooltipItem } from '@/entities/pricing';

import SRTDownloadImg from '@/shared/assets/images/pricing/featureTooltips/srt-download.jpg';
import TeamspacesImg from '@/shared/assets/images/pricing/featureTooltips/teamspaces.jpg';
import UserPromptingImg from '@/shared/assets/images/pricing/featureTooltips/translation-prompting.png';
import { SRT_DOWNLOAD_DOC_LINK, TEAMSPACES_DOC_LINK, USER_PROMPT_FAQ_LINK } from '@/shared/constants/docLinks';
import { Translate } from '@/shared/i18n';
import { BoosterType } from '@/shared/types/Billing';

export const getBoosterTooltipMap = (t: Translate): Record<BoosterType, FeatureTooltipItem> => ({
  [BoosterType.SRT]: {
    title: t('boosters.item.srt.tooltip'),
    image: SRTDownloadImg,
    link: SRT_DOWNLOAD_DOC_LINK,
  },
  [BoosterType.TeamspaceSeat]: {
    title: t('boosters.item.seat.tooltip'),
    image: TeamspacesImg,
    link: TEAMSPACES_DOC_LINK,
  },
  [BoosterType.TranslationPrompting]: {
    description: t('boosters.item.prompting.tooltip'),
    image: UserPromptingImg,
    link: USER_PROMPT_FAQ_LINK,
  },
});
